import {Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild} from "@angular/core";
import {FileInfo, UploadResponse} from "../../Models/FileModels";
import {CdkDragDrop, CdkDragEnter, moveItemInArray} from "@angular/cdk/drag-drop";
import {getAuthToken} from "../../api/AuthHeaders";
import {HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {FormBuilder} from "@angular/forms";
import {MainService} from "../../Services/service.service";
import {ActivatedRoute} from "@angular/router";
import {DTOImage} from "../../api/WickedApiClient";
import {environment} from "src/environments/environment";


@Component({
  selector: "image-attach",
  templateUrl: "./image-attach.component.html",
  styleUrls: ["./image-attach.component.scss"]
})
export class ImageAttachComponent implements OnInit {


  constructor(private HttpClient: HttpClient, private fb: FormBuilder,
    public services: MainService, private route: ActivatedRoute
  ) {

  }

  @Input() maxAttachments: number = -1;

  @ViewChild("fileInput", {static: false}) fileInput: ElementRef;

  ngOnInit(): void {

  }

  imagesChanged: boolean = false;

  private _selectedImage: FileInfo;
  public get selectedImage(): FileInfo {
    return this._selectedImage;
  }

  uploadFile(file: FileInfo) {
    const url = "/File/TemporaryUpload";
    let formData = new FormData();
    let token = getAuthToken();
    const headers = new HttpHeaders(); //.set('Content-Type', 'multipart/form-data');
    const httpRequestParams = new HttpParams();
    headers.set("Authorization", "Bearer " + token);
    formData.set("file", file.file, file.file.name);
    this.services.progress = true;
    this.HttpClient.post(url, formData, {
      headers: headers,
      observe: "events",
      params: httpRequestParams,
      reportProgress: true,
      responseType: "json"
    }).subscribe(
      (event: HttpEvent<Object>) => {
        if(event.type === HttpEventType.UploadProgress) {
          file.progressPercentage = Math.floor((event.loaded * 100) / event.total);
          file.loaded = event.loaded;
        }
        if(event.type == HttpEventType.Response) {
          var eventResponse = <HttpResponse<UploadResponse>>event;
          if(eventResponse.body && eventResponse.ok) {
            file.fileName = eventResponse.body.files[0].localFilename;
            file.isUploading = false;
            file.imageUrl = `${environment.apiBaseUrl}/FileGet/${file.fileName}`;
          }
          if(this.images.length > 0) {
            this.setImagesIsUploaded.emit(true);
          }
          this.services.progress = false;
        }
      },
      (error: any) => {
        file.isUploading = false;
        this.services.progress = false;
      },
      () => {
      }
    );
  }


  isImage(file: File) {
    let name = file.name.toLowerCase();
    return name.endsWith(".jpg") || name.endsWith(".gif") || name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".bmp");
  }

  @Output() maxAttachmentsExceeded = new EventEmitter();
  @Output() setImagesIsUploaded = new EventEmitter();

  addFiles(files: File[]) {
    if(this.images.length + files.length > this.maxAttachments) {
      this.maxAttachmentsExceeded.emit();
      return;
    } else {
      for(var i = 0;i < files.length;i++) {
        this.addFile(files[i]);
      }
    }
  }

  addFile(file: File) {
    if(this.isImage(file)) {
      const fi = new FileInfo();
      fi.file = file;
      fi.fileName = file.name;
      fi.name = file.name;
      fi.orgFileName = file.name;
      const reader = new FileReader();
      reader.onload = e => {
        fi.imageUrl = <string>reader.result;
        this.images.push(fi);
        this.updateImageIndexes();
        this.uploadFile(fi);
        if(!this.selectedImage) {
          this.selectedImage = fi;
        }
        this.imagesChanged = true;
      };
      reader.readAsDataURL(fi.file);
    }
  }

  This: any = this;

  private deleteImage(file: FileInfo) {
    this.images = this.images.filter(x => x.orderIndex != file.orderIndex);
    this.images.forEach((img, index) => {
      img.orderIndex = index;
    });

    if(this.selectedImage == file) {
      if(this.images.length > 0) {
        this.selectedImage = this.images[0];
      } else {
        this.selectedImage = undefined;
      }
      //  this.selectedImage =
    }

    if(this.images.length < 1) {
      this.setImagesIsUploaded.emit(false);
    }
    this.imagesChanged = true;
  }


  public set selectedImage(value: FileInfo) {
    if(value != this._selectedImage) {
      this.imagesChanged = true;
    }
    this._selectedImage = value;
  }

  images: FileInfo[] = [];

  @Input() title: string = "Drag files here";

  @Input() subtitle: string = "";


  entered(event: CdkDragEnter<string[]>) {
    console.log("entered");
  }

  public dtoImages(): DTOImage[] {
    return this.images.map(img => {
      const dtoImg = new DTOImage();
      dtoImg.init({orgFileName: img.orgFileName, fileName: img.fileName});
      return dtoImg
    });
  }

  drop(event: CdkDragDrop<FileInfo[]>) {
    if(event.previousIndex != event.currentIndex) {
      moveItemInArray(this.images, event.previousIndex, event.currentIndex);
      this.updateImageIndexes();
      this.imagesChanged = true;
    }
  }

  onFileSelected(event) {
    const inputNode: any = event.target
    let fileList = (inputNode.files as FileList);
    if(this.maxAttachments < 1 || this.images.length + fileList.length > this.maxAttachments) {
      this.maxAttachmentsExceeded.emit();
      this.fileInput.nativeElement.value = "";
      return;
    }
    for(var i = 0;i < fileList.length;i++) {
      this.addFile(fileList.item(i));
    }
    this.fileInput.nativeElement.value = "";
  }

  private updateImageIndexes() {
    this.images.forEach((img, index) => {
      img.orderIndex = index;
    });
  }

  overAction(i: number) {

  }

  cdkDragStarted($event, childItem, i) {

  }

  cdkDragReleased($event, i) {

  }

  clear() {
    this.images = [];
  }
}
